import React from 'react';

import {
  DescriptionItem,
  DescriptionList,
  Link,
  Paper,
  Typography,
} from '@gogame/components';

import BusinessPartnerDetails from 'scenes/BusinessPartners/components/BusinessPartnerDetails';

import { Status } from './Status';

export default ({ data, openChildComponent }) => {
  const handleOpenBusinessPartner = () => {
    openChildComponent(BusinessPartnerDetails, {
      id: data.businessPartner.id,
    });
  };
  return {
    color: 'info',
    date: data.time,
    title: (
      <Typography>
        <span>Postback - </span>
        <Link onClick={handleOpenBusinessPartner}>
          {data.businessPartner.name}
        </Link>
      </Typography>
    ),
    content: (
      <Paper
        sx={{ padding: 2, marginTop: 1, width: '100%' }}
        variant={'outlined'}
        elevation={0}
      >
        <DescriptionList
          termWidth={'200px'}
          data={data}
          disableGutters={true}
          stripEmpty={true}
        >
          <DescriptionItem
            label={'Business Partner ID'}
            field={'businessPartner.id'}
            placeholder={'—'}
          />
          <DescriptionItem
            label={'Status'}
            field={'status'}
            type={'status'}
            valueParser={(value) => ({ id: value })}
            statusFactory={Status}
          />
          <DescriptionItem label={'URL'} field={`url`} placeholder={'—'} />
        </DescriptionList>
      </Paper>
    ),
  };
};
